export enum DashboardRanking {
  Absent = "Absent",
  Amended = "Amended",
  Late = "Late",
  OnLeave = "OnLeave",
  Overtime = "Overtime",
  Undertime = "Undertime",
}
